import React from "react";
import { callApi } from "../../utils/api";
import { Measure } from "./ManageMeasurement";
import { ToastsStore } from "react-toasts";

declare var $: any;
interface AllProps {
  selectedMeasure: Measure;
  listMeasure: any;
}
class AddMeasurement extends React.Component<AllProps> {
  state = {
    measureDetail: { id: 0, name: "" },
    isLoading: false
  };
  componentWillReceiveProps(nextState) {
    this.setState({ measureDetail: nextState.selectedMeasure });
  }
  handleChange = (e: any) => {
    const measureDetail: any = this.state.measureDetail;
    measureDetail[e.target.name] = e.target.value;
    this.setState({ measureDetail });
  };
  handleSaveResponse = (response: any) => {
    if (
      response.result === false ||
      (response.message && response.message.indexOf("Already Exist") !== -1)
    ) {
      ToastsStore.error(response.message || "Failed to save measure label");
      return;
    }
    this.props.listMeasure();
    $("#measure-form").modal("hide");
    ToastsStore.success(response.message || "Measure saved successfully");
  };
  saveMeasure = () => {
    if (this.state.isLoading) {
      return;
    }
    const measureDetail = { ...this.state.measureDetail };
    measureDetail.name = measureDetail.name ? measureDetail.name.trim() : "";
    if (!measureDetail.name) {
      ToastsStore.error("Measure label is required");
      return;
    }
    if (measureDetail.id) {
      measureDetail.id = Number(measureDetail.id);
    }
    this.setState({ isLoading: true, measureDetail });
    callApi("POST", "measurement_master.php", measureDetail)
      .then(res => res.data)
      .then(response => {
        this.handleSaveResponse(response);
      })
      .catch(err => {
        console.log(err);
        ToastsStore.error("Something went wrong, please try again");
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };
  render() {
    return (
      <div
        className="modal fade"
        id="measure-form"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Measure Form</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label className="col-form-label">Measure Label:</label>{" "}
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Measure Label"
                    onChange={e => {
                      this.handleChange(e);
                    }}
                    value={
                      this.state.measureDetail.name
                        ? this.state.measureDetail.name
                        : ""
                    }
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={this.state.isLoading}
                onClick={this.saveMeasure}
              >
                {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddMeasurement;
